export const LEGACY_SESSION_STORAGE_KEYS = Object.freeze(["token", "support_token"]);

export const USER_SESSION_POLICY = Object.freeze({
  snapshotStorageKey: "user",
  sessionHintKey: "aethercv_auth_present",
  sessionEvent: "aethercv-user-session",
  logoutPath: "/auth/logout",
  bootstrapPath: "/user/me",
});

export const SUPPORT_SESSION_POLICY = Object.freeze({
  snapshotStorageKey: "support_user",
  sessionHintKey: "aethercv_support_session",
  sessionEvent: "aethercv-support-session",
  logoutPath: "/support/logout",
  bootstrapPath: "/support/me",
});

export const COOKIE_SESSION_POLICY = Object.freeze({
  transport: "httpOnly-cookie",
  storage: Object.freeze({
    allowed: Object.freeze([
      "sanitized user snapshot",
      "sanitized support snapshot",
      "boolean session hint flags",
      "sessionStorage API response cache",
    ]),
    forbidden: LEGACY_SESSION_STORAGE_KEYS,
  }),
});

export const clearLegacySessionTokens = () => {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") return;
  for (const key of LEGACY_SESSION_STORAGE_KEYS) {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // Ignore storage removal errors.
    }
  }
};
